import { IDessert } from '../../../../models/IDessert';
import { IFormSchema } from '../../../../models/ISchema';

export const fieldSchema: IFormSchema<Pick<IDessert, 'name' | 'description' | 'isActive'>> = {
  name: {
    initialValue: '',
    rules: {
      required: true,
      minLength: 3,
      maxLength: 48,
    },
  },
  description: {
    initialValue: '',
  },
  isActive: {
    initialValue: true,
  },
};
